module.exports = __webpack_public_path__ + "img/pic6.16725bf2.png";